import React, { Component, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { config } from '../../Constants';
import global from '../global';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import { Link } from 'react-router-dom';
import { Card, Row, Col, InputGroup, FormControl, Button } from 'react-bootstrap';
import { Layout } from '../Layout';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import queryString from 'query-string';
import download from 'downloadjs';
import exclamationtriangle from '../../Asset/app/media/img/icons/exclamation-triangle.svg';
import NexdmsmImg from '../../Asset/Images/nexdigm-logo-sm.png';
import $ from 'jquery';
import Select from 'react-select';
import { getYearOptions } from '../../utils/yearUtil';
/*import React, { useEffect, useState } from "react";*/

const expandRow = {
    renderer: row => (
        <div>
            {/*<p className="m-t-10">{`DP ID: ${row.NAME_CSV}`}</p>*/}
        </div>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true

};


const yearoptions = getYearOptions();
export class Dashboard extends Component {


    constructor(props) {
        super(props);
        this.state = {
            showCookieModal: false,
            PendingCount: 0,
            CompletedCount: 0,
            NRCount: 0,
            ORCount: 0,
            RemitterLogo: 'client-logo.png',
            RemitterStyle: '80%',
            divLogin: true,
            loading: false,
            showDecModal: false,
            showLoginDecModal: false,
            showCompDecModal: false,
            showNRDecModal: false,
            PendingDecList: [],
            isYesNoOpen: false,
            showYearModal:false,
            AssingmentcodeList: [],
            PanList: [],
            DPIDList: [],
            columns: [
                {
                    dataField: 'checkbox',
                    text: '',
                    headerAlign: 'center',
                    align: 'center',
                    formatter: (rowContent, row) => {
                        return (
                            <div>
                                {<input type="checkbox" name="cbkAssignment" id={row.AssignmentCode} value={row.AssignmentCode}
                                    onChange={(e) => this.handleCheckbox(e, row.PAN, row.NAME_CSV)} className="form-check-input" />}
                            </div>
                        )
                    }
                },
                {
                    dataField: 'AssignmentName',
                    text: 'Assignment Name',
                    headerAlign: 'center',
                    sort: true,
                },
                {
                    dataField: 'AssignmentCode',
                    text: 'Assignment Code',
                    headerAlign: 'center',
                    sort: true,
                    hidden: true
                },
                {
                    dataField: 'PAN',
                    text: 'PAN',
                    headerAlign: 'center',
                    sort: true,
                    value: 'PAN',
                    hidden: true
                },
                {
                    dataField: 'NAME_CSV',
                    text: 'DP ID / Folio ID',
                    headerAlign: 'center',
                    sort: true,
                    hidden: true
                },
                //{
                //    dataField: "Fill",
                //    text: "Fill Form",
                //    headerAlign: 'center',
                //    align: 'center',
                //    formatter: (rowContent, row) => {
                //        return (
                //            <div>
                //                <button className="btn btn-primary p-10"
                //                    onClick={e => {
                //                        e.persist();

                //                        window.location.href = config.url.Web_URL + `/Resident/Form15GH` + '?AC=' + window.btoa(this.state.AssignmentCode) + '&DP=' + window.btoa(row.DPID) + '&PN=' + window.btoa(row.PAN);

                //                    }}> <FontAwesomeIcon icon="pencil-alt" /> </button>
                //            </div>
                //        )
                //    }
                //},
            ],

            CompDecList: [],
            columnsComp: [
                {
                    dataField: 'RemitterName',
                    text: 'Listed Company Name',
                    headerAlign: 'center',
                    sort: true,

                },

                {
                    dataField: 'PAN',
                    text: 'PAN',
                    headerAlign: 'center',
                    sort: true,
                },

                {
                    dataField: 'BeneficiaryName',
                    text: 'Shareholder Name as per Trading Account',
                    headerAlign: 'center',
                    align: 'center',
                    sort: true,
                },
                {
                    dataField: 'DPID',
                    text: 'DP ID / Folio ID',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: "Download",
                    text: "Download",
                    headerAlign: 'center',
                    align: 'center',
                    formatter: (rowContent, row) => {
                        return (
                            <div>
                                <button className="btn btn-primary p-10"
                                    onClick={e => {
                                        e.persist();
                                        Dashboard.handleEdit(row.PDFLoc, row.UniqueIDNo);
                                    }}> <FontAwesomeIcon icon="cloud-download-alt" /> </button>
                            </div>
                        )
                    }
                },
            ],
            NRDecList: [],
            columnsNR: [
                {
                    dataField: 'RemitterName',
                    text: 'Listed Company Name',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'BeneficiaryName',
                    text: 'Shareholder Name as per Trading Account',
                    headerAlign: 'center',
                    align: 'center',
                    sort: true,
                },
                {
                    dataField: 'DPID',
                    text: 'DP ID / Folio ID',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: "Download",
                    text: "Download Documents",
                    headerAlign: 'center',
                    align: 'center',
                    formatter: (rowContent, row) => {
                        return (
                            <div>
                                <button className="btn btn-primary p-10"
                                    onClick={e => {
                                        e.persist();
                                        Dashboard.handleNRDownload(row.ZipLoc, row.BeneficiaryName);
                                    }}> <FontAwesomeIcon icon="cloud-download-alt" /> </button>
                            </div>
                        )
                    }
                },
            ],
            ORDecList: [],
            columnsOR: [
                {
                    dataField: 'RemitterName',
                    text: 'Listed Company Name',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'BeneficiaryName',
                    text: 'Shareholder Name as per Trading Account',
                    headerAlign: 'center',
                    align: 'center',
                    sort: true,
                },
                {
                    dataField: 'ResidentType',
                    text: 'Resident Type',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'PAN',
                    text: 'PAN',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'DPID',
                    text: 'DP ID / Folio ID',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: "Download",
                    text: "Download Documents",
                    headerAlign: 'center',
                    align: 'center',
                    formatter: (rowContent, row) => {
                        return (
                            <div>
                                <button className="btn btn-primary p-10"
                                    onClick={e => {
                                        e.persist();
                                        Dashboard.handleNRDownload(row.ZipLoc, row.BeneficiaryName);
                                    }}> <FontAwesomeIcon icon="cloud-download-alt" /> </button>
                            </div>
                        )
                    }
                },
            ],
            AssignmentCode: -1,
            IsLogin: 0,
            URL: config.url.Web_URL,
            isResidentVisible: "none",
            isNonResidentVisible: "none",
            isOtherResidentVisible: "none",
            ShareholderType: "",
            PAN: '',
            NAME_CSV: '',
            ischecked: 1,
            isCompletedCountYesNoOpen: false,
            DPID: '',
            Email: '',
            OTP: '',
            showTiming: 'none',
            showReOTP: 'none',
            showValidateOTP: 'none',
            seconds: 600,
            time: {},
            IsForm121OnlyActive: '0',
            selectedyear: ''
        };

        const parsed = queryString.parse(window.location.search);
        this.state.AssignmentCode = window.atob(parsed['AC']);
        this.state.flag = window.atob(parsed['flag']);
        this.state.DPID = parsed['DP'] == undefined ? 0 : window.atob(parsed['DP']);
        this.state.PAN = parsed['PN'] == undefined ? 0 : window.atob(parsed['PN']);

        this.initialState = this.state;
        localStorage.clear(); //for localStorage
        sessionStorage.clear(); //for sessionStorage
        
        this.handleCompletedDeclaration.bind(this.state.CompletedCount, this.state.ShareholderType, this.state.PendingCount, this.state.Email);
        this.handleChange = this.handleChange.bind(this);
        this.handleValidate = this.handleValidate.bind(this);
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);

        this.setState({
            isClickheretoedittheformlink: false
        });
        this.getIP();
    }

    getIP() {
        $.getJSON("https://api.ipify.org?format=json",
            function (data) {
                // Displayin IP address on screen
                console.log(data.ip);
                axios.get(global.UserManagement.SetClientIpAPI + "?ipAddr=" + data.ip).then(() => { });
            });
    }

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer() {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds == 0) {
            clearInterval(this.timer);
            this.setState({ showReOTP: 'block', showTiming: 'none' });
        }
    }

    static handleEdit(rowContent1, rowContent2) {

        axios.get(global.Form15GH.DownloadDigiSignedPdfAPI + '?pdfLocation=' + rowContent1,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/pdf' },
                responseType: 'blob'
            })
            .then(response => {
                const content = response.headers['content-type'];
                const fileName = rowContent2 + '.pdf'
                download(response.data, fileName, content)

            })
            .catch(error => {
                console.log(error);
            });
    }

    static handleNRDownload(rowContent1, rowContent2) {

        axios.get(global.Form15GH.DownloadNRDocumentsAPI + '?zipLocation=' + rowContent1,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/zip' },
                responseType: 'blob'
            })
            .then(response => {
                const content = response.headers['content-type'];
                const fileName = rowContent2 + '.zip'
                download(response.data, fileName, content)

            })
            .catch(error => {
                console.log(error);
            });
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    componentDidMount() {

        axios.get(global.UserManagement.GetSessionDetailsAPI)
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        IsLogin: response.data.IsLogin,
                    });

                }

            })
            .catch(error => {
                console.log(error);
            });

        axios.get(global.Resident.GetDematAccountCountAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&flag=' + this.state.flag)
            .then(response => {
                if (response.data.Status) {

                    if (response.data.ShareholderType == "Resident") {
                        this.setState({
                            isResidentVisible: "block",
                            isNonResidentVisible: "none",
                            isOtherResidentVisible: "none"
                        });
                    }
                    else if (response.data.ShareholderType == "Non-Resident") {
                        this.setState({
                            isResidentVisible: "none",
                            isNonResidentVisible: "block",
                            isOtherResidentVisible: "none"
                        });
                    }
                    else if (response.data.ShareholderType == "Other-Resident") {
                        this.setState({
                            isResidentVisible: "none",
                            isNonResidentVisible: "none",
                            isOtherResidentVisible: "block"
                        });
                    }

                    this.setState({
                        PendingCount: response.data.PendingCount,
                        CompletedCount: response.data.CompletedCount,
                        NRCount: response.data.NRCount,
                        ORCount: response.data.ORCount,
                        ShareholderType: response.data.ShareholderType,
                        Email: response.data.Email,
                        IsForm121OnlyActive: response.data.IsForm121OnlyActive
                    });
                    this.handleCompletedDeclaration(response.data.CompletedCount, response.data.ShareholderType, response.data.PendingCount, response.data.Email);
                }
                else {
                    this.showNoti("Notification", "Unable to Load Demat Account Count. Kindly Try Again.", "danger");
                    setTimeout(() => { window.location.href = config.url.Web_URL; }, 10000);
                    return;
                }
            })
            .catch(error => {
                this.showNoti("Notification", error, "danger");
                return;
            });

    }

    toggleORModal = (e) => {

        if (this.state.IsLogin == 1) {

            e.preventDefault();

            axios.get(global.Resident.GetDematAccountDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode,
                { responseType: 'json' })
                .then(response => {
                    if (response.data.Status) {

                        this.setState({
                            ORDecList: response.data.ORDecList,
                            showORDecModal: true
                        });
                    }
                    else {
                        this.setState({
                            ORDecList: [],
                            showORDecModal: false
                        });
                        this.showNoti("Notification", "Unable to Load Demat Account Details. Kindly Try Again.", "danger");
                        setTimeout(() => { window.location.href = config.url.Web_URL; }, 10000);
                        return;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
        else {
            this.setState({
                showLoginDecModal: true
            });
        }

    }

    toggleNRModal = (e) => {

        if (this.state.IsLogin == 1) {

            e.preventDefault();

            axios.get(global.Resident.GetDematAccountDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&flag=' + this.state.flag,
                { responseType: 'json' })
                .then(response => {
                    if (response.data.Status) {

                        this.setState({
                            NRDecList: response.data.NRDecList,
                            showNRDecModal: true
                        });
                    }
                    else {
                        this.setState({
                            NRDecList: [],
                            showNRDecModal: false
                        });

                        this.showNoti("Notification", "Unable to Load Demat Account Details. Kindly Try Again.", "danger");
                        setTimeout(() => { window.location.href = config.url.Web_URL; }, 10000);
                        return;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
        else {
            this.setState({
                showLoginDecModal: true
            });
        }

    }

    toggleCompDecModal = (e) => {

        if (this.state.IsLogin == 1) {

            e.preventDefault();

            axios.get(global.Resident.GetDematAccountDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&flag=' + this.state.flag,
                { responseType: 'json' })
                .then(response => {
                    if (response.data.Status) {

                        this.setState({
                            CompDecList: response.data.CompDecList,
                            showCompDecModal: true
                        });
                    }
                    else {
                        this.setState({
                            CompDecList: [],
                            showCompDecModal: false
                        });

                        this.showNoti("Notification", "Unable to Load Demat Account Details. Kindly Try Again.", "danger");
                        setTimeout(() => { window.location.href = config.url.Web_URL; }, 10000);
                        return;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
        else {
            this.setState({
                showLoginDecModal: true
            });
        }

    }

    toggleLoginDecModal = (e) => {
        this.setState({
            showLoginDecModal: true
        });
    }

    handleLogin = (e) => {
        window.location.href = config.url.Web_URL + '/SignIn';
    };

    handleSignUp = (e) => {
        window.location.href = config.url.Web_URL + '/SignUp';
    };

    toggleDecModal = (e) => {

        e.preventDefault();
        this.setState({
            isYesNoOpen: false
        });

        this.state.flagYN = "N";
        axios.get(global.Resident.GetDematAccountAssignmentDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&flag=' + this.state.flag + '&flagYN=' + this.state.flagYN,
            { responseType: 'json' })
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        PendingDecList: response.data.PendingDecList,
                        CompDecList: response.data.CompDecList,
                        showDecModal: true
                    });
                }
                else {
                    this.setState({
                        PendingDecList: [],
                        CompDecList: [],
                        showDecModal: false
                    });

                    this.showNoti("Notification", "Unable to Load Demat Account Details. Kindly Try Again.", "danger");
                    setTimeout(() => { window.location.href = config.url.Web_URL; }, 10000);
                    return;
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    toggleDematModal = (e) => {

        this.state.flagYN = "Y";
        axios.get(global.Resident.GetDematAccountAssignmentDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&flag=' + this.state.flag + '&flagYN=' + this.state.flagYN,
            { responseType: 'json' })
            .then(response => {
                if (response.data.Status) {
                    if (response.data.PendingDecList.length == 0) {
                        this.setState({
                            isYesNoOpen: false
                        });
                    }
                    else {
                        this.setState({
                            isYesNoOpen: true
                        });
                    }
                }
                else {
                    this.showNoti("Notification", "Unable to Load Demat Account Details. Kindly Try Again.", "danger");
                    setTimeout(() => { window.location.href = config.url.Web_URL; }, 10000);
                    return;
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    modalClose = (e) => {

        this.setState({
            showDecModal: false,
            showLoginDecModal: false,
            showCompDecModal: false,
            showNRDecModal: false,
            showORDecModal: false
        });
    }

    closeYesNoModal = (e) => {
        this.setState({
            isYesNoOpen: false
            //showYearModal:true
        });
    }

    YearProceed = () => {
        if (this.state.selectedyear === '2025-2026') {
            window.location.href = config.url.Web_URL + `/Resident/Form15GH` + '?AC=' + window.btoa(this.state.AssingmentcodeList.map(item => item.value).join(',')) + '&DP=' + window.btoa(this.state.DPIDList.map(item => item.NAME_CSV).join(',')) + '&PN=' + window.btoa(this.state.PanList.map(item => item.PAN).join(',')) ;
        }
        else {
            window.location.href = config.url.Web_URL + `/Resident/Form121` + '?AC=' + window.btoa(this.state.AssingmentcodeList.map(item => item.value).join(',')) + '&DP=' + window.btoa(this.state.DPIDList.map(item => item.NAME_CSV).join(',')) + '&PN=' + window.btoa(this.state.PanList.map(item => item.PAN).join(',')) + '&FY=' + window.btoa(this.state.selectedyear);
        }
    }

    closeYearModal = () => {
        this.setState({
            showYearModal: false
        });
    }

    closeRefillForm15GHYesNoModal = () => this.setState({ isCompletedCountYesNoOpen: false });

    addItemIfNotPresent = (newItem) => {
        this.setState((prevState) => {
            // Check if the item is not already present in firmList       
            if (!prevState.AssingmentcodeList.some(item => item.value === newItem.value)) {
                // If not present, add the new item to the firmList         
                return { AssingmentcodeList: [...prevState.AssingmentcodeList, newItem], };
            }
            // If the item is already present, return the current state unchanged       
            return prevState;
        });
    };

    addItemIfNotPresent1 = (PAN) => {

        this.setState((prevState) => {
            if (!prevState.PanList.some(item => item.value === PAN)) {
                return { PanList: [...prevState.PanList, PAN], };
            }
            return prevState;
        });
    };

    addItemIfNotPresent2 = (NAME_CSV) => {

        this.setState((prevState) => {
            if (!prevState.DPIDList.some(item => item.value === NAME_CSV)) {
                return { DPIDList: [...prevState.DPIDList, NAME_CSV], };
            }
            return prevState;
        });
    };

    // Function to add an item to firmList   
    addItem = (newItem, PAN, NAME_CSV) => {
        this.setState((prevState) =>
            ({ AssingmentcodeList: [...prevState.AssingmentcodeList, newItem], }));

        this.setState((prevState) =>
            ({ PanList: [...prevState.PanList, PAN], }));

        this.setState((prevState) =>
            ({ DPIDList: [...prevState.DPIDList, NAME_CSV], }));
    };
    // Function to remove an item from firmList   
    removeItem = (itemToRemove) => {
        this.setState((prevState) =>
            ({ AssingmentcodeList: prevState.AssingmentcodeList.filter(item => item.value !== itemToRemove.value), }));
    };

    removeItem1 = (itemToRemove) => {
        this.setState((prevState) =>
            ({ PanList: prevState.PanList.filter(item => item.value !== itemToRemove.value), }));
    };

    removeItem2 = (itemToRemove) => {
        this.setState((prevState) =>
            ({ DPIDList: prevState.DPIDList.filter(item => item.value !== itemToRemove.value), }));
    };

    handleCheckbox = (e, PAN, NAME_CSV) => {
        const { value, checked } = e.target;
        if (checked) {

            this.addItemIfNotPresent({ value });
            this.addItemIfNotPresent1({ PAN });
            this.addItemIfNotPresent2({ NAME_CSV });
        }
        // Case 2  : The user unchecks the box        
        else {
            this.removeItem({ value });
            this.removeItem1({ PAN });
            this.removeItem2({ NAME_CSV });
        }
    }

    toggleSelectAssignmentModal = (e) => {
        e.preventDefault();
        if (this.state.AssingmentcodeList.length === 0) {
            this.showNoti("Notification", "Please select atleast one Assignment Name", "danger");
            return;
        }
        else {

            if (this.state.selectedyear === '') {

                this.showNoti("Notification", "Please select year", "danger");
                return;
            }

            if (this.state.IsForm121OnlyActive === '0' && this.state.selectedyear === '2025-2026') {
                window.location.href = config.url.Web_URL + `/Resident/Form15GH` + '?AC=' + window.btoa(this.state.AssingmentcodeList.map(item => item.value).join(',')) + '&DP=' + window.btoa(this.state.DPIDList.map(item => item.NAME_CSV).join(',')) + '&PN=' + window.btoa(this.state.PanList.map(item => item.PAN).join(','));
            }
            else {
                window.location.href = config.url.Web_URL + `/Resident/Form121` + '?AC=' + window.btoa(this.state.AssingmentcodeList.map(item => item.value).join(',')) + '&DP=' + window.btoa(this.state.DPIDList.map(item => item.NAME_CSV).join(',')) + '&PN=' + window.btoa(this.state.PanList.map(item => item.PAN).join(',')) + '&FY=' + window.btoa(this.state.selectedyear);
            }

        }
    }

    handleCompletedDeclaration(CompletedCount, ShareholderType, PendingCount) {

        if (CompletedCount > 0 && ShareholderType == "Resident") {

            this.setState({
                isClickheretoedittheformlink: true,
                isCompletedVisible: "block"
            });
        }
        if (PendingCount > 0 && ShareholderType == "Resident") {
            this.setState({
                isClickheretoedittheformlink: false,
                isCompletedVisible: "none"
            });
        }
    }

    toggleCompletedDeclarationModal = (e) => {
        this.setState({
            isCompletedCountYesNoOpen: true
        });
    }

    toggleRefillForm15GHModal = (e) => {
        e.preventDefault();

        const sendOTPEmail = this.state;

        axios.post(global.UserManagement.SendResetOTP, sendOTPEmail)
            .then(json => {
                if (json.data.status) {
                    this.setState({
                        showValidateOTP: 'block'
                    });

                    this.showNoti("Notification", "OTP sent successfully; check on your entered email.", "success");
                    this.timer = setInterval(this.countDown, 1000);
                    this.setState({ isCompletedCountYesNoOpen: false, isOPTOpen: true, showReOTP: 'none', showTiming: 'block', time: {}, seconds: 600, OTP: '' });
                }
                else {
                    this.showNoti("Notification", json.data.message, "danger");

                }
            }
            )
        this.setState({ isCompletedCountYesNoOpen: false, isOPTOpen: true, showReOTP: 'none', showTiming: 'block', time: {}, seconds: 600 });
    }

    handleClick = (e) => {
        // Handle click event here
        e.preventDefault();
        const sendOTPEmail = this.state;

        axios.post(global.UserManagement.SendResetOTP, sendOTPEmail)
            .then(json => {
                if (json.data.status) {
                    this.setState({
                        showValidateOTP: 'block'
                    });

                    this.showNoti("Notification", "OTP sent successfully; check on your entered email.", "success");
                    //this.timer = setInterval(this.countDown, 1000);
                    this.setState({ showReOTP: 'none', showTiming: 'block', time: {}, seconds: 600 });
                }
                else {
                    this.setState({ isOPTOpen: true, showTiming: 'block', time: {}, seconds: 600, OTP: '' });
                    this.showNoti("Notification", json.data.message, "danger");

                }
            }
            )
    };

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleValidate(e) {
        if (this.state.OTP == '') {
            this.showNoti("Notification", "Please enter OTP.", "danger");
            return;
        }

        if (isNaN(this.state.OTP)) {
            this.showNoti("Notification", "Invalid OTP.", "danger");
            return;
        }

        this.state.Form15GHEditflagYN = "Y";
        const OTP = this.state;

        axios.post(global.UserManagement.ValidateResetOTPNew, OTP)
            .then(json => {
                if (json.data.status) {

                    this.setState({
                        showValidateOTP: 'none',
                        showReOTP: 'none',
                        showTiming: 'none'

                    });
                    this.showNoti("Notification", "OTP validated successfully.", "success");

                    axios.get(global.Form15GH.GetCompletedForm15GHAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&PAN=' + this.state.PAN + '&DPID=' + this.state.DPID + '&CompletedCount=' + this.state.CompletedCount)
                        .then(response => {
                            if (response.status) {
                                if (response.data.Form15GHDetails[0].FormType === "FORM121") {
                                    window.location.href = config.url.Web_URL + `/Resident/Form121` + '?AC=' + window.btoa(this.state.AssignmentCode) + '&DP=' + window.btoa(this.state.DPID) + '&PN=' + window.btoa(this.state.PAN); //+ '&CR=' + window.btoa(this.state.CompletedCount)
                                } else {
                                    window.location.href = config.url.Web_URL + `/Resident/Form15GH` + '?AC=' + window.btoa(this.state.AssignmentCode) + '&DP=' + window.btoa(this.state.DPID) + '&PN=' + window.btoa(this.state.PAN) + '&FY=' + window.btoa(this.state.selectedyear); //+ '&CR=' + window.btoa(this.state.CompletedCount)
                                }
                            }
                            else {
                                this.showNoti("Notification", response.Message, "danger");
                            }
                        }).catch(error => {
                            this.setState({ loading: false });
                        });

                }
                else {
                    this.showNoti("Notification", json.data.message, "danger");
                }
            });

    }

    handleclose = (e) => {
        this.setState({ isCompletedCountYesNoOpen: false, isOPTOpen: false, showReOTP: 'none', showTiming: 'none', time: {}, seconds: 600, OTP:'' });
    };


    handleYear(e) {
        if (e.value != undefined) {
            this.setState({ selectedyear: e.label });
        }
    }

    render() {
        let content = Layout.RenderNavMenu();

        const options = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.PendingDecList.length
        };

        const contentTable = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="DPID"
                    columns={this.state.columns}
                    data={this.state.PendingDecList}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                /*{expandRow={expandRow}}*/
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );

        const optionsComp = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.CompDecList.length
        };

        const contentTableComp = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="DPID"
                    columns={this.state.columnsComp}
                    data={this.state.CompDecList}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                /*{expandRow={expandRow}}*/
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );

        const optionsNR = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.NRDecList.length
        };

        const contentTableNR = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="DPID"
                    columns={this.state.columnsNR}
                    data={this.state.NRDecList}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );

        const optionsOR = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.ORDecList.length
        };

        const contentTableOR = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="DPID"
                    columns={this.state.columnsOR}
                    data={this.state.ORDecList}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );

        const labelStyle = {
            textAlign: 'center'
        };

        let contentFooter = Layout.RenderFooter();

        return (

            <div>
                <ReactNotification />

                {/*PENDING DEC. MODAL*/}
                <Modal isOpen={this.state.showDecModal} size="mg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader toggle={this.modalCloseCompDec} charCode="X"><b>Select schemes to proceed with filling form:</b></ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                <PaginationProvider
                                    pagination={
                                        paginationFactory(options)
                                    }
                                >
                                    {contentTable}
                                </PaginationProvider>
                            </Col>
                        </Row>
                        {/*{this.state.IsForm121OnlyActive === '0' && (*/}

                            <Row>
                                <Col md={6} className="m-t-10 cursor-not-allowed-disable-dropdown">
                                <label htmlFor="status" className="required-field">Select Tax Year</label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="Select Year"
                                    isDisabled={false}
                                    options={yearoptions}
                                    value={yearoptions.find(obj => obj.label === this.state.selectedyear)}
                                        onChange={this.handleYear.bind(this)}
                                    />

                                </Col>
                            </Row>
                       {/* )}*/}
                       
                    </ModalBody>

                    <ModalFooter>
                        <button className="btn btn-success" type="button" onClick={this.toggleSelectAssignmentModal} disabled={!this.state.ischecked}>Select</button>
                        <button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>
                    </ModalFooter>
                </Modal>

                {/*COMPLETED DEC. MODAL*/}
                <Modal isOpen={this.state.showCompDecModal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader toggle={this.modalCloseCompDec} charCode="X"><b>Resident Declaration Submitted Details</b></ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                <PaginationProvider
                                    pagination={
                                        paginationFactory(optionsComp)
                                    }
                                >
                                    {contentTableComp}
                                </PaginationProvider>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>
                    </ModalFooter>
                </Modal>

                {/*NON Resident DEC. MODAL*/}
                <Modal isOpen={this.state.showNRDecModal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader toggle={this.modalCloseNRDec} charCode="X"><b>Non Resident Declaration Details</b></ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                <PaginationProvider
                                    pagination={
                                        paginationFactory(optionsNR)
                                    }
                                >
                                    {contentTableNR}
                                </PaginationProvider>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>
                    </ModalFooter>
                </Modal>

                {/*Other Resident DEC. MODAL*/}
                <Modal isOpen={this.state.showORDecModal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader toggle={this.modalCloseORDec} charCode="X"><b>Other Resident Declaration Details</b></ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                <PaginationProvider
                                    pagination={
                                        paginationFactory(optionsOR)
                                    }
                                >
                                    {contentTableOR}
                                </PaginationProvider>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>
                    </ModalFooter>
                </Modal>

                {/*LOGIN DEC MODAL*/}
                <Modal isOpen={this.state.showLoginDecModal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader toggle={this.modalCloseCompDec} charCode="X"><b>Resident Declaration Details</b></ModalHeader>

                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                To access your previous records, <a onClick={this.handleLogin} className="dc-login">Login</a> or <a onClick={this.handleSignUp} className="dc-login">Sign up</a> to view your completed declarations.
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.isYesNoOpen} size="lg" style={{ display: "auto", width: "616px" }}>
                    <div>
                        <img src={exclamationtriangle} width="50" style={{ display: "block", marginLeft: "292px", marginTop: "12px" }} />
                    </div>
                    <ModalBody>
                        <Row>
                            <Col md={13} className="session-modal-text">
                                You have more than one Demat Account linked to this PAN through which you have subscribed to other schemes as well.
                            </Col>
                        </Row>
                        <Row>
                            <Col md={13} className="dc-text">
                                Do you want to fill the form for all schemes linked to this PAN number?
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" type="button" onClick={this.toggleDecModal}>Yes</button>
                        <button className="btn btn-danger m-l-10" type="button" onClick={this.closeYesNoModal}>No</button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.isCompletedCountYesNoOpen} size="lg" aria-labelledby="contained-modal-title-vcenter" centered
                    style={{ borderradius: '25px', display: "auto", width: "716px" }}>
                    <ModalBody>
                        <Row>
                            <Col md={13} className="session-modal-text">
                                Are you sure you want to refill previously submitted form?
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" type="button" onClick={this.toggleRefillForm15GHModal}>Yes</button>
                        <button className="btn btn-danger m-l-10" type="button" onClick={this.closeRefillForm15GHYesNoModal}>No</button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.isOPTOpen} size="lg" aria-labelledby="contained-modal-title-vcenter" centered style={{ display: "auto", width: "616px" }}>
                    <ModalBody id="contained-modal-title-vcenter">
                        <Row>
                            <Col md={13} className="session-modal-text">
                                An OTP has been sent to your email address {this.state.Email}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                <div className="form-group m-form__group" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <label className="required-field m-t-20" style={labelStyle}>Enter the OTP</label>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={6}>
                                <FormControl
                                    type="text"
                                    name="OTP"
                                    placeholder="Format: 123456"
                                    value={this.state.OTP}
                                    onChange={this.handleChange}
                                    maxLength="6"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} className="session-modal-text">
                                <div style={{ textAlign: 'end' }}>
                                    <span onClick={this.handleClick} style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer', marginright: '-132px' }}>
                                        Resend the OTP
                                    </span>
                                </div>
                            </Col>
                            <Col md={6} className="session-modal-text">
                                <div style={{ textAlign: 'start', fontsize: 'smaller' }}>
                                    <div style={{ display: `${this.state.showTiming}` }}>
                                        <button>Time Remaining: {this.state.time.m} : {this.state.time.s}  </button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                <div style={{ textAlign: 'center' }}>
                                    <button className="btn btn-success m-l-8 m-t-10" type="button" onClick={this.handleValidate}>Submit</button>
                                    <button className="btn btn-danger m-l-8 m-t-10" onClick={this.handleclose}> Close </button>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

              {/*  {this.state.IsForm121OnlyActive === '0' && (*/}
                <Modal isOpen={this.state.showYearModal} size="mg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader charCode="X"><b>Select Tax Year</b></ModalHeader>
                    <ModalBody>
                       {/* {this.state.IsForm121OnlyActive === '0' && (*/}

                            <Row>
                                <Col md={6} className="m-t-10 cursor-not-allowed-disable-dropdown">
                                <label htmlFor="status" className="required-field">Select Tax Year</label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="Select Year"
                                    isDisabled={false}
                                    options={yearoptions}
                                    value={yearoptions.find(obj => obj.label === this.state.selectedyear)}
                                        onChange={this.handleYear.bind(this)}
                                    />

                                </Col>
                            </Row>
                        {/*)}*/}

                    </ModalBody>
                    

                    <ModalFooter>
                        {/*<button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>*/}
                            <button className="btn btn-success" type="button" onClick={this.YearProceed}>Proceed</button>
                            <button className="btn btn-dark m-l-10" type="button" onClick={this.closeYearModal}>Close</button>
                    </ModalFooter>
                </Modal>
               {/* )}*/}
                <div className="m-grid m-grid--hor m-grid--root m-page">
                    {content}
                    <div className="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
                        <div className="m-grid__item m-grid__item--fluid m-wrapper">
                            <div className="m-subheader " >
                                <div className="d-flex align-items-center">
                                    <div className="mr-auto">
                                        <h3 className="m-subheader__title ">
                                            {this.state.ShareholderType} Beneficiary Declaration
                                        </h3>
                                    </div>
                                </div>
                            </div>

                            <Row>
                                <Col md={3} style={{ display: `${this.state.isResidentVisible}` }}>
                                    <a onClick={this.toggleDematModal} >
                                        <div className="card rounded align-content-center w-90 m-l-20">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h3 className="bold dc_title">
                                                        Pending Declaration
                                                    </h3>
                                                </div>
                                                <div>
                                                    <h1 className="bold dc-count">{this.state.PendingCount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </Col>
                                <Col md={3} style={{ display: `${this.state.isResidentVisible}` }}>
                                    <a onClick={this.toggleCompDecModal}>
                                        <div className="card rounded align-content-center w-90 m-l-20">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h3 className="bold dc_title">
                                                        Completed Declaration
                                                    </h3>
                                                </div>
                                                <div>
                                                    <h1 className="bold dc-count">{this.state.CompletedCount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </Col>
                                <Col md={2} style={{ display: `${this.state.isCompletedVisible}`, marginTop: '176px', padding: 'initial', fontsize: 'larger' }}>
                                    <div>
                                        {this.state.isClickheretoedittheformlink && (
                                            <span onClick={this.toggleCompletedDeclarationModal} style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>
                                                Click here to edit the form
                                            </span>
                                        )}
                                        {/*<p><b><a href="https://example.com" onClick={this.toggleCompletedDeclarationModal} className="text-bold" target="_blank" style={{ fontsize: 'larger' }} >Click here to edit the form</a></b></p>*/}
                                    </div>
                                </Col>
                                <Col md={3} style={{ display: `${this.state.isNonResidentVisible}` }}>
                                    <a onClick={this.toggleNRModal}>
                                        <div className="card rounded align-content-center w-90 m-l-20">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h3 className="bold dc_title">
                                                        Non Resident Documents
                                                    </h3>
                                                </div>
                                                <div>
                                                    <h1 className="bold dc-count">{this.state.NRCount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </Col>
                                <Col md={3} style={{ display: `${this.state.isOtherResidentVisible}` }}>
                                    <a onClick={this.toggleORModal}>
                                        <div className="card rounded align-content-center w-90 m-l-20">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h3 className="bold dc_title">
                                                        Other Resident Documents
                                                    </h3>
                                                </div>
                                                <div>
                                                    <h1 className="bold dc-count">{this.state.ORCount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </Col>
                            </Row>

                        </div>
                    </div>
                </div>

                {contentFooter}
            </div>
        );
    }
}
